enum RemarkType {
	Green = "Green",
	Orange = "Orange",
	Red = "Red"
}

export default RemarkType;